<template>
    <div v-if="settings.show">
        <b-modal v-model="showInfoModal"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onClose"></span>
            </template>

            <div class="modal-icon" v-if="settings.icon" :style="getIconStyle()"></div>
            <h2 class="modal-title">{{settings.title}}</h2>
            <div class="modal-subtitle">{{settings.subtitle}}</div>
            
            <video loop autoplay muted playsinline width="800" height="600" name="Video Name" :src="getVideo()"></video>

            <template v-slot:modal-footer>
                <b-button v-if="settings.showCancelButton" variant="default" class="secondary" @click="onClose">
                    <template v-if="settings.cancelButtonText">{{ settings.cancelButtonText }}</template>
                    <template v-else>{{ translate('Cancel') }}</template>
                </b-button>
                <b-button v-if="!settings.hideOkButton" class="btn-primary" variant="primary" @click="onOk()">
                    <template v-if="settings.okButtonText">{{ settings.okButtonText }}</template>
                    <template v-else>{{translate('OK')}}</template>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import errorMixin from '@/mixins/errorMixin';
    import {mapMutations, mapState} from "vuex";
    import _ from "lodash";

    export default {
        name: "welcomeModal",

        data() {
            return {
                showInfoModal: _.isEmpty(this.settings),
            }
        },
        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        watch: {
            settings(newValue) {
                this.showInfoModal = !_.isEmpty(newValue)
            }
        },
        methods: {
            async onClose() {
                this.showInfoModal = false
                if (this.settings.onCancelHandler) {
                    try {
                        await this.settings.onCancelHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
                this.handleDisplayData()
            },
            async onOk() {
                this.showInfoModal = false
                if (this.settings.onOkHandler) {
                    try {
                        await this.settings.onOkHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
                this.handleDisplayData()
            },
            handleDisplayData() {
                if (!this.settings.helpCenterSidebar) {
                    localStorage.setItem(this.settings.key + '_lastDisplayPopup', (new Date()).toUTCString())
                    let getPopupCount = (+(localStorage.getItem(this.settings.key + "_displayCount") || 0) + 1)
                    localStorage.setItem(this.settings.key + "_displayCount", getPopupCount)
                }
            },
            getVideo() {
                if(this.settings.video) {
                    return require(`@/assets/video/${this.settings.video}`)
                }
            },
            getIconStyle() {
                if (this.settings.icon) {
                    return {
                        backgroundImage: 'url(' + require(`@/assets/icons/${this.settings.icon}`) + ')'
                    }
                } else {
                    return null
                }
            },
        }
    }
</script>

<style scoped>
    .modal-title {
        padding-bottom: 15px;
        padding-top: 10px;
    }
    .modal-subtitle img {
        margin-left: 5px;
        margin-right: 5px;
    }
    .modal-subtitle {
        padding-bottom: 15px;
    }
    .custom-modal .btn.btn-primary {
        background-color: #3F405C;
    }

    @media screen and (max-width: 770px) {
        video {
            width: 800px !important;
            height: 250px !important;
        }
    }
</style>